import StyledTypo from '@tmh-website/styles/typo';
import Button from '@tmh-website/ui/Button';
import ButtonIcon from '@tmh-website/ui/ButtonIcon';
import styled from 'styled-components';
import { LocaleSwitchBannerThemeColor, localeSwitchBannerThemes } from './LocaleSwitchBanner.theme';

export const Main = styled.div<{ $themeColor: LocaleSwitchBannerThemeColor }>`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;
  width: 100%;
  color: ${props => props.theme.color[localeSwitchBannerThemes[props.$themeColor].text]};
  background: ${props => props.theme.color[localeSwitchBannerThemes[props.$themeColor].background]};
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: ${props => props.theme.localeSwitchBannerHeightSmallMobile};
  padding: 8px 0;
  @media (${props => props.theme.breakpoint.sm.up}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: ${props => props.theme.localeSwitchBannerHeight};
    padding: 0;
  }
`;

export const Text = styled(StyledTypo.Typography)`
  margin: 0 32px 8px 0;
  opacity: ${({ theme }) => theme.textOpacity};
  @media (${props => props.theme.breakpoint.sm.up}) {
    margin: 0 8px 0 0;
  }
  @media (${props => props.theme.breakpoint.lg.up}) {
    font-size: 16px;
    font-weight: ${props => props.theme.fontWeight.medium};
  }
  @media (max-width: 600px) {
    font-size: 12px;
  }
  &:last-child {
    margin: 0;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  @media (max-width: 330px) {
    margin: 0 -10px;
  }

  > * {
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const AdjutedButton = styled(Button)`
  @media (${props => props.theme.breakpoint.sm.down}) {
    margin: 0;
  }
`;

export const AdjustedButtonIcon = styled(ButtonIcon)`
  @media (${props => props.theme.breakpoint.sm.down}) {
    position: absolute;
    top: 8px;
    right: -16px;
  }
`;
